import { createAction } from '../../utils/redux/createAction';
import { consts as upcomingSurveyConsts } from '../surveys/upcoming-survey';

const actionsScope = 'healthboard/appointment-survey-assignment';

export const APPOINTMENT_SURVEY_ASSIGNMENTS = {
  SET_SURVEYS: `${actionsScope}/set-surveys`,
  SET_ASSIGNMENT_ID: `${actionsScope}/set-assignment-id`,
};

export const preVisitConsentsModalActions = {
  setSurveys: createAction(APPOINTMENT_SURVEY_ASSIGNMENTS.SET_SURVEYS),
  setAssignmentId: createAction(
    APPOINTMENT_SURVEY_ASSIGNMENTS.SET_ASSIGNMENT_ID,
  ),
};

const initialState = {
  surveys: [],
  assignmentId: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case APPOINTMENT_SURVEY_ASSIGNMENTS.SET_SURVEYS: {
      return {
        ...state,
        surveys: payload,
      };
    }

    case APPOINTMENT_SURVEY_ASSIGNMENTS.SET_ASSIGNMENT_ID: {
      return {
        ...state,
        assignmentId: payload,
      };
    }

    case upcomingSurveyConsts.CLEAR: {
      return {
        ...initialState,
        surveys: state.surveys,
      };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/appointment-survey-assignment.js